import React from 'react';
import './SkeletonLoaderTutorFlow.css'; // Custom CSS file for skeleton styling

const SkeletonLoaderTutorFlow = () => {
  return (
    <section className="how-it-works-skeleton">
      <div className="container">
        <div className="section-header text-center">
          <div className="skeleton-heading">
            <div className="skeleton-img" />
            <div className="skeleton-title" />
            <div className="skeleton-img" />
          </div>
          <div className="skeleton-subtitle" />
          <div className="skeleton-paragraph" />
        </div>
        <div className="row justify-content-center">
          {/* Card 1 */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="feature-box-skeleton">
              <div className="skeleton-icon" />
              <div className="skeleton-text" />
              <div className="skeleton-paragraph short" />
            </div>
          </div>
          {/* Card 2 */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="feature-box-skeleton">
              <div className="skeleton-icon" />
              <div className="skeleton-text" />
              <div className="skeleton-paragraph short" />
            </div>
          </div>
          {/* Card 3 */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="feature-box-skeleton">
              <div className="skeleton-icon" />
              <div className="skeleton-text" />
              <div className="skeleton-paragraph short" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkeletonLoaderTutorFlow;
